import { createErrorStore } from "../../../../error";
import type { TFieldKey } from "@./suf-store";
import { SignupFlowSlug } from "../constants";

/**
 * Zustand store for tracking validation errors and validated fields.
 */
export const useSignupFlowErrorStore = createErrorStore<TFieldKey, SignupFlowSlug>(
  "suf-error-store",
);
